import { Country, Language } from './lists.model';
import { User } from './user.model';

export class Organisation {
  id: number;

  name: string;
  urlLogo: string;
  address: string;
  addressExtra: string;
  postcode: string;
  city: string;
  country: Country;
  phone: string;

  employees: User[];

  sectorOwner: User;
  negoceOwner: User;

  defaultLanguageGui: Language;
  defaultLanguagePdf: Language;

  hasBeApi: boolean;
  hasI18n: boolean;
}
